import { render, staticRenderFns } from "./wordsOperationHistory.vue?vue&type=template&id=024167c4&scoped=true"
import script from "./wordsOperationHistory.vue?vue&type=script&lang=js"
export * from "./wordsOperationHistory.vue?vue&type=script&lang=js"
import style0 from "./wordsOperationHistory.vue?vue&type=style&index=0&id=024167c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024167c4",
  null
  
)

export default component.exports